import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://ckqixpskizvhvxbfczbi.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNrcWl4cHNraXp2aHZ4YmZjemJpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM0NDg0NDMsImV4cCI6MjA4OTAyNDQ0M30.3RJN4TgovCCavwNOjfOTdcqHnP5w5jQBhdDA6Ysuj5A'

export const supabase = createClient(supabaseUrl, supabaseKey)